import {
    combineReducers,
    logAction,
    useSnackMiddleware,
    useRelodeReducer,
} from "@relode/core";
import * as React from "react";

import { candidateReducer } from "./candidate";
import { changeStatusReducer } from "./statusChanges";
import { CandidateState, initialCandidateState } from "./candidateState";
import {
    FeatureActions,
    useCombinedCandidatesFeatureActions,
} from "./combinedCandidatesFeatureActions";
import { useCombinedLeadsFeatureHandlers } from "./combinedCandidatesFeatureHandlers";
import { uiReducer } from "./ui";

const combinedReducers = combineReducers(
    uiReducer,
    candidateReducer,
    changeStatusReducer
);

type ICandidateContext = {
    state: CandidateState;
    actions: FeatureActions;
};

export const CandidateContext = React.createContext<ICandidateContext>(
    undefined
);

export const useCandidateContext = () => {
    const context = React.useContext(CandidateContext);
    if (!context) {
        throw new Error(
            "useCandidateContext must be used within an appropriate provider"
        );
    }
    return context;
};

export const CandidateProvider = (props: { children: React.ReactNode }) => {
    const [state, dispatch] = useRelodeReducer(
        combinedReducers,
        initialCandidateState,
        [useSnackMiddleware(), logAction]
    );

    const actions = useCombinedCandidatesFeatureActions(state, dispatch);
    useCombinedLeadsFeatureHandlers(state, actions);

    const value = {
        state,
        actions,
    } as ICandidateContext;
    return <CandidateContext.Provider value={value} {...props} />;
};
